import { v4 as uuidV4 } from 'uuid';
import * as ajax from '../actions/ajax';
import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';
import uploadUtils from '../utils/uploadUtils';
const CONTENT_TYPE = 'application/json';

/**
 *  Upload a value to the customer's files as a JSON file, straight to S3 through a presigned
 *  URL, so large inputs for server work (e.g. stageRunBehavior) never travel in a request.
 *
 *  source.value   the value to upload
 *  source.folder  folder under the customer's files (default 'uploads')
 *
 *  Returns { success: true, fileName } or { success: false, message }.
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions) => {
  const resolve = value => evaluateSource(value, content, parentContentPath, transientContext, nativeFunctions);
  const value = await resolve(source.value);
  const folder = source.folder ? await resolve(source.folder) : 'uploads';
  const fileName = `${folder}/${uuidV4()}.json`;
  try {
    const uploadUrl = await uploadUtils.getS3UploadUrl(fileName, CONTENT_TYPE);
    // Presigned S3 URL: no API base, no auth header; the signed content type must match.
    await ajax.put(uploadUrl, JSON.stringify(value), CONTENT_TYPE, 'text', false, false, false);
    return {
      success: true,
      fileName
    };
  } catch (e) {
    return {
      success: false,
      message: e.message || 'Upload failed'
    };
  }
};
export default {
  evaluate
};